import { useState, useEffect } from 'react';
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import styles from './stylesLeagueRow.module.css';

import SortableItem from '../SortableItem/SortableItem';
import { useReorderLiveEvents } from '../../../../../queries/useReorderLiveEvent';

const LeagueRow = ({
  league,
  setLeague,
  order,
  toggleStatus,
  togglePin,
  etype,
  columns,
  sportId,
}) => {
  const { mutate: setEntityOrder } = useReorderLiveEvents();
  const [isExpanded, setIsExpanded] = useState(false);

  const sensors = useSensors(useSensor(PointerSensor));

  const { attributes, setNodeRef, transform, transition } = useSortable({
    id: league.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = league.events.findIndex(
      (event) => event.event_id === active.id
    );
    const newIndex = league.events.findIndex(
      (event) => event.event_id === over.id
    );

    let updatedEvents = arrayMove(league.events, oldIndex, newIndex);

    updatedEvents = updatedEvents.map((event, index) => ({
      ...event,
      display_order: index + 1,
    }));

    setLeague((prev) =>
      prev.map((l) =>
        l.league_id === league.league_id ? { ...l, events: updatedEvents } : l
      )
    );

    setEntityOrder({
      orderedIds: updatedEvents.map((event) => event.event_id),
      parentId: league.league_id,
      sportId,
    });
  };

  useEffect(() => {
    if (!!league.expand) {
      setIsExpanded(true);
    }
  }, [league.expand]);

  return (
    <>
      <tr
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={styles.leagueRow}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <td className={styles.leagueCell} colSpan={columns.length}>
          <div className={styles.iconContainer}>
            {/* <div className={styles.liveIcon}>
              <img src={league.image} alt="league" />
            </div> */}
            <div className={styles.rowTitle}>
              <p>{league.league_name}</p>
            </div>
          </div>
        </td>
        <td className={styles.leagueCell}>
          <button className={styles.toggleButton}>
            {isExpanded ? <DownOutlined /> : <UpOutlined />}
          </button>
        </td>
      </tr>

      {isExpanded && (
        <>
          {league.events.map((event, index) => {
            if (!event.pinned_order) return null;
            return (
              <SortableItem
                key={event.event_id}
                event={event}
                index={index}
                toggleStatus={toggleStatus}
                togglePin={togglePin}
                name={league.ename}
                etype={etype}
                columns={columns}
                hideClipPath
              />
            );
          })}

          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={league.events
                .filter((e) => !e.pinned_order)
                .map((e) => e.event_id)}
              strategy={verticalListSortingStrategy}
            >
              {league.events.map((event, index) => {
                if (event.pinned_order) return null;
                return (
                  <SortableItem
                    key={event.event_id}
                    event={event}
                    index={index}
                    toggleStatus={toggleStatus}
                    togglePin={togglePin}
                    name={league.ename}
                    etype={etype}
                    columns={columns}
                  />
                );
              })}
            </SortableContext>
          </DndContext>
        </>
      )}
    </>
  );
};

export default LeagueRow;
